// extracted by mini-css-extract-plugin
module.exports = {"mainSection":"MainSection_pc_mainSection__vsZ28","pubDate":"MainSection_pc_pubDate__QkliD"};